import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import nestleLogo from '../../assets/images/logo.svg';
import { useDispatch } from 'react-redux';
import { TabNameChange } from '../../store/Actions';
import UserDetailsServices from '../../services/console_services/LoginLogot';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f0f0f0', // Gray background
    },
    content: {
        textAlign: 'center',
    },
    logo: {
        width: 150,
        marginBottom: theme.spacing(3),
    },
    message: {
        fontSize: '1.2rem',
        color: '#007bff',
    },
}));

const ErrorPage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        UserDetailsServices.getUserDetails().then(data => {
            if (data) {
                localStorage.setItem('userDetails', JSON.stringify(data));
                if (data?.loginLogOutDetails[0]?.LastViewPage) {
                    if (data?.loginLogOutDetails[0]?.LastViewPage === "/sno") {
                        dispatch(TabNameChange('SNO'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/dom") {
                        dispatch(TabNameChange('DOM'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/do") {
                        dispatch(TabNameChange('DO'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/dp") {
                        dispatch(TabNameChange('DP'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/dip") {
                        dispatch(TabNameChange('DIP'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/cp") {
                        dispatch(TabNameChange('CP'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/fgs") {
                        dispatch(TabNameChange('FGS'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/poos") {
                        dispatch(TabNameChange('POOS'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/rr") {
                        dispatch(TabNameChange('RR'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/if") {
                        dispatch(TabNameChange('IF'));
                    } else if (data?.loginLogOutDetails[0]?.LastViewPage === "/nps") {
                        dispatch(TabNameChange('NPS'));
                    }
                    navigate(data?.loginLogOutDetails[0]?.LastViewPage);
                }
            }
        });
    }, []);

    return (
        <Container className={classes.root}>
            <div className={classes.content}>
                <img
                    src={nestleLogo}
                    alt="Nestle Logo"
                    className={classes.logo}
                />
                <Typography variant="h5" className={classes.message}>
                    You do not have the necessary access. Please contact the administrator to request the required permissions.
                </Typography>
            </div>
        </Container>
    );
};

export default ErrorPage;
